"use client";

import React from "react";
import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function AccountabilityOutcomes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const standards = [{
    title: "Defensible Billing",
    description: "Transparent financial practices ensuring every dollar is accounted for and audit-ready."
  }, {
    title: "Functional Reporting",
    description: "Detailed, evidence-based progress reports that track capacity building and goal achievement."
  }, {
    title: "Xero Integration",
    description: "Seamless accounting integration for reliable, professional, and organized financial records."
  }, {
    title: "Compliance-Aware Operations",
    description: "Operating strictly within NDIS guidelines with drafted service agreements and comprehensive insurance."
  }, {
    title: "Measurable Outcomes",
    description: "Structured tracking systems designed to demonstrate tangible participant progress over time."
  }];
  return;
}